import { RouteDefinition } from 'Routes';
import { extendsType } from 'shared/utils/ts-utils';
import { PlanningLayout } from './layouts';
import { paths } from './paths';

// The master definition for the OGP routes.
// Each route has the shape of a RouteDefinition, but we can still read all route-specific data.

export const routes = extendsType<Record<string, RouteDefinition>>()({
  ...paths,
  Dashboard: {
    ...paths.Dashboard,
    layout: PlanningLayout,
  },
  FlexPools: {
    ...paths.FlexPools,
    layout: PlanningLayout,
  },
  WorkTemplates: {
    ...paths.WorkTemplates,
    layout: PlanningLayout,
  },
  WorkTemplatesCreate: {
    ...paths.WorkTemplatesCreate,
    layout: PlanningLayout,
  },
  WorkTemplatesDuplicate: {
    ...paths.WorkTemplatesDuplicate,
    layout: PlanningLayout,
  },
  WorkTemplatesEdit: {
    ...paths.WorkTemplatesEdit,
    layout: PlanningLayout,
  },
  WorkTemplatesDetail: {
    ...paths.WorkTemplatesDetail,
    layout: PlanningLayout,
  },
  Workforce: {
    ...paths.Workforce,
    layout: PlanningLayout,
  },
  EmployeeDetail: {
    ...paths.EmployeeDetail,
    layout: PlanningLayout,
  },
  EmployeeCreate: {
    ...paths.EmployeeCreate,
    layout: PlanningLayout,
  },
  EmployeeUpdate: {
    ...paths.EmployeeUpdate,
    layout: PlanningLayout,
  },
  EmployeeCertificateAdd: {
    ...paths.EmployeeCertificateAdd,
    layout: PlanningLayout,
  },
  PartnerWorkerDetail: {
    ...paths.PartnerWorkerDetail,
    layout: PlanningLayout,
  },
  Departments: {
    ...paths.Departments,
    layout: PlanningLayout,
  },
  DepartmentCreate: {
    ...paths.DepartmentCreate,
    layout: PlanningLayout,
  },
  DepartmentDetail: {
    ...paths.DepartmentDetail,
    layout: PlanningLayout,
  },
  DepartmentEdit: {
    ...paths.DepartmentEdit,
    layout: PlanningLayout,
  },
  DepartmentDuplicate: {
    ...paths.DepartmentDuplicate,
    layout: PlanningLayout,
  },
  ShiftPlanning: {
    ...paths.ShiftPlanning,
    layout: PlanningLayout,
  },
  Projects: {
    ...paths.Projects,
    layout: PlanningLayout,
  },
  Availability: {
    ...paths.Availability,
    layout: PlanningLayout,
    requiredFeatureFlags: ['allowAvailability'],
  },
  CollegialLending: {
    ...paths.CollegialLending,
    layout: PlanningLayout,
    requiredFeatureFlags: ['allowCollegialLending'],
  },
} as const);

export type RouteKeys = keyof typeof routes;
